import UserStatus from './UserStatus';

export default UserStatus;
